import { inject, Injectable } from '@angular/core';
import { STUDY_X_OF_Y_SECONDARY_VALUES_KPIS } from '@catalogues';
import { Kpi, KpiKeys, KpiTypes } from '@models';

import { CommonFunctionsService } from '../common-functions/common-functions.service';

@Injectable({
  providedIn: 'root'
})
export class KpiCommonFunctionsService {
  private commonFunctionsService: CommonFunctionsService = inject(CommonFunctionsService);
  getKpiDisplayValue(kpi: Kpi, kpiKey: KpiKeys): string | number | undefined {
    if (kpi.value === undefined) return;

    switch (kpi.type) {
      case 'percent':
        return this.commonFunctionsService.roundValue(kpi.value * 100, 1);
      case 'days':
        return this.commonFunctionsService.formatNumberWithCommas(Math.trunc(kpi.value));
      case 'number':
        return kpiKey === 'deviation_rate_per_subject'
          ? this.commonFunctionsService.roundValue(kpi.value, 2)
          : this.commonFunctionsService.formatNumberWithCommas(kpi.value);
      default:
        return kpi.value;
    }
  }

  getKpiDisplayUnit(kpiType: KpiTypes): '%' | '' {
    return kpiType === 'percent' ? '%' : '';
  }

  getKpiDisplaySecondaryValue(kpi: Kpi, kpiKey: KpiKeys): string | undefined {
    const { numerator, denominator } = kpi;
    if (numerator == null || denominator == null) return;
    if (numerator === undefined || denominator === undefined) return;

    if (STUDY_X_OF_Y_SECONDARY_VALUES_KPIS.includes(kpiKey)) {
      const format = (val: number) => Number(val.toFixed(1));
      return `${format(numerator)} of ${format(denominator)}`;
    }

    return;
  }
}
